<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <ul class="navbar-nav">
            <!-- Avatar -->

            <a class="nav-link  d-flex align-items-center" id="navbarDropdownMenuLink" role="button" (click)="logout()"
                aria-expanded="false"><i class="fa fa-sign-out"></i>
                Logout

            </a>

            <!-- <i class="material-icons">logout</i>Logout -->


        </ul>
    </div>
</nav>

<!-- Small modal -->





<!-- <div *ngIf="fail_show" class="alert" [class.visible]="isVisible"> 
  {{fail_mgs}}
</div> -->
<mat-tab-group mat-align-tabs="center" (selectedTabChange)="tabClick($event)">
    <mat-tab label="Add User">
        <div class="container">

            <form #addUserListForm="ngForm" (ngSubmit)="addUserListForm.valid && addTryBuyUser(addUserListForm.value)">
                <div class="row" style="text-align: center;">
                    <div class="col-md-6">
                        <div class="form-group">
                            <mat-form-field appearance="outline" style="width: 90%;">
                                <input matInput placeholder="Select Vehicle" aria-label="chassisNumber"
                                    [matAutocomplete]="auto" #userTyperef="ngModel" [(ngModel)]="p.chassisNumber"
                                    name="chassisNumber" (ngModelChange)="doFilter()" required />
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let chassis of chassislist" [value]="chassis">
                                        {{ chassis }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>



                    <div class="col-md-6">
                        <div class="form-group">
                            <mat-form-field appearance="outline" style="width: 90%;">
                                <mat-label>First Name</mat-label>
                                <input matInput placeholder="FirstName" name="imei" #userTyperef="ngModel"
                                    [(ngModel)]="p.firstName" name="firstName" required>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="row" style="text-align: center;">
                    <div class="col-md-6">
                        <div class="form-group">
                            <mat-form-field appearance="outline" style="width: 90%;">
                                <mat-label>Last Name</mat-label>
                                <input matInput placeholder="FirstName" #userTyperef="ngModel" [(ngModel)]="p.lastName"
                                    name="lastName" required>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <mat-form-field appearance="outline" style="width: 90%">
                                <mat-label>Mobile Number</mat-label>
                                <input matInput placeholder="mobileNumber" #userTyperef="ngModel"
                                    [(ngModel)]="p.mobileNumber" name="mobileNumber" pattern="[0-9]*" minlength="10"
                                    maxlength="10" required>
                            </mat-form-field>
                        </div>
                    </div>
                </div>


                <div class="row" style="text-align: center;">
                    <div class="col-md-6">
                        <div class="form-group">
                            <mat-form-field appearance="outline" style="width: 90%;">
                                <mat-label>Dealer Name</mat-label>
                                <input matInput placeholder="dealerName" #userTyperef="ngModel"
                                    [(ngModel)]="p.dealerName" name="dealerName" required>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div *ngIf="fail_show1" style="color:green ;padding-left: 5%;text-align: center;">
                    {{fail}}
                </div>
                <div *ngIf="!fail_show1" style="color:red ;padding-left: 5%;text-align: center;">
                    {{fail}}
                </div>
                <div style="text-align: center;">
                    <button type="submit" id="submit" mat-raised-button
                        style="background:#000000;color:#ffffff;font-weight: bold; margin-top: 3%;font-family: 'Open Sans', sans-serif;">Submit</button>
                </div>
                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" class="alignCards" style="text-align: center;">
                    <!-- <div *ngIf="fail_show1" style="color:red ;">
                                    {{fail_mgs1}}
                                </div> -->
                </div>

            </form>

        </div>
    </mat-tab>
    <mat-tab label="Add Vehicle">
        <div class="container">
            <form class="form" #addUserForm="ngForm" (ngSubmit)="addUserForm.valid && addUser(addUserForm.value)">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">

                            <mat-form-field style="width: 90%;" appearance="outline">
                                <mat-label>Chassis Number</mat-label>
                                <input matInput placeholder="chassisNumber" #userTyperef="ngModel"
                                    [(ngModel)]="q.chassisNumber" name="chassisNumber" autocomplete="off" required>

                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <mat-form-field style="width: 90%;" appearance="outline">
                                <mat-label>Battery SerialNumber</mat-label>
                                <input matInput #userTyperef="ngModel" [(ngModel)]="q.batterySerialNumber"
                                    name="batterySerialNumber" required>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <mat-form-field style="width:90% ;" appearance="outline">
                                <mat-label>Model</mat-label>
                                <mat-select [(ngModel)]="q.model" name="model" (selectionChange)="onModelChange($event.value)" required>
                                    <mat-option *ngFor="let model of list" [value]="model">{{model.model}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        </div>
                        <div class="col-md-6">
                        <div  *ngIf="selectedModel">
                            <mat-form-field style="width: 90%;" appearance="outline">
                              <mat-label>VCU Number</mat-label>
                              <input matInput [(ngModel)]="q.vcuNumber" name="vcuNumber" required>
                            </mat-form-field>
                          </div>
                          </div>
                   
                </div>
                <!-- <mat-form-field style="width: 47%;" appearance="outline">
                            <mat-label>color</mat-label>
                            <input matInput placeholder="FirstName" name="imei" required>
                        </mat-form-field> -->
                <div *ngIf="fail_show" style="color:green ;text-align: center;    padding-right: 10%;">
                    {{fail_mgs}}
                </div>
                <div *ngIf="!fail_show" style="color:red ;text-align: center;    padding-right: 10%;">
                    {{fail_mgs}}
                </div>
                <div fxFlex.gt-sm="25" fxFlex.gt-xs="100" fxFlex="100" class="alignCards" style="text-align: center;padding-right: 100px;">
                    <button type="submit" id="submit" mat-raised-button
                        style="background:#000000;color:#ffffff;font-weight: bold; margin-top: 3%;font-family: 'Open Sans', sans-serif;">Submit</button>
                </div>
                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" class="alignCards" style="text-align: center;">
                    <!-- <div *ngIf="fail_show1" style="color:red ;">
                                    {{fail_mgs1}}
                                </div> -->
                </div>

            </form>

        </div>

    </mat-tab>
    <mat-tab label="View Vehicles">
        <div class="matero-row" fxLayout="row wrap">


            <mat-form-field appearance="outline">

                <mat-label style="color: #000 ;">Search Vehicle</mat-label>
                <input matInput #input (keyup)="applyFilter($event)">
                <button mat-button matPrefix mat-icon-button>
                    <mat-icon style="color:  #000;">search</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div>

        </div>

        <div *ngIf="fail__log" style="color:red ;padding-left: 5%">
            {{failLogDetail}}
        </div>
        <mat-table [dataSource]="swappingStationList" matSort class="mat-elevation-z8">

            <ng-container matColumnDef="chassisNumber">
                <mat-header-cell style="font-size: 10px;width: 10px;" *matHeaderCellDef><b style="color: #000;">Chassis
                        Number</b>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" data-label="chassisNumber"> {{element.chassisNumber}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="batterySerialNumber">
                <mat-header-cell style="font-size: 10px;width: 10px;" *matHeaderCellDef><b style="color: #000;">Battery
                        SerialNumber</b>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" data-label="batterySerialNumber"> {{element.batterySerialNumber}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="mobileNumber">
                <mat-header-cell style="font-size: 10px;" *matHeaderCellDef><b style="color: #000;">Mobile Number</b>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" data-label="mobileNumber"> {{element.mobileNumber}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Access">
                <mat-header-cell style="font-size: 10px;" *matHeaderCellDef><b style="color: #000;"> Remove
                        Access</b>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" data-label="Access">
                    <button class="fa fa-ban" title="remove Access" [disabled]="element.mobileNumber === 'Not assigned'"
                        (click)="removeAccess(element,'Deactivate')"
                        style="font-size: x-large;border-width:inherit;background-color:#fff;color: #000000; "></button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; " class="mat-header-row--sticky">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;"></mat-row>
        </mat-table>
        <mat-paginator [pageSizeOptions]="[6, 15, 25,50]" showFirstLastButtons></mat-paginator>




    </mat-tab>


</mat-tab-group>